import React, { useState, useEffect, useRef } from 'react';
import './Hero.css';
import { FaPlay, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// ✅ Correct image imports
import HeroImg1 from '../assets/imgs/hero1.jpg';
import HeroImg2 from '../assets/imgs/hero2.jpg';
import HeroImg3 from '../assets/imgs/hero3.png';
import HeroImg4 from '../assets/imgs/hero4.png';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const textRef = useRef(null);
  const ctaRef = useRef(null);

  // ✅ Correct image assignment (no curly braces around variables)
  const slides = [
    {
      image: HeroImg1,
      alt: 'Studio equipment and setup'
    },
    {
      image: HeroImg2,
      alt: 'Photography session in progress'
    },
    {
      image: HeroImg3,
      alt: 'Video production team working'
    },
    {
      image: HeroImg4,
      alt: 'Video production team working'
    }
  ];

  // Auto-rotate slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Animation effects
  useEffect(() => {
    setTimeout(() => {
      if (textRef.current) {
        textRef.current.style.opacity = '1';
        textRef.current.style.transform = 'translateY(0)';
      }
    }, 300);

    setTimeout(() => {
      if (ctaRef.current) {
        ctaRef.current.style.opacity = '1';
        ctaRef.current.style.transform = 'translateY(0)';
      }
    }, 800);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <section className="hero">
      {/* Image Slider */}
      <div className="slider-container" ref={sliderRef}>
        {slides.map((slide, index) => (
          <div 
            key={index}
            className={`slider-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            aria-hidden={index !== currentSlide}
          >
            <div className="slider-overlay"></div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button className="slider-arrow left" onClick={prevSlide} aria-label="Previous slide">
          <FaChevronLeft />
        </button>
        <button className="slider-arrow right" onClick={nextSlide} aria-label="Next slide">
          <FaChevronRight />
        </button>

        {/* Slide Indicators */}
        <div className="slider-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="container">
          <div className="hero-text" ref={textRef}>
            <h1>Eskista Rentals</h1>
            <p className="subtitle">State-of-the-art facilities for photographers, filmmakers, and content creators</p>
          </div>

          {/* <div className="hero-cta" ref={ctaRef}>
            <button className="cta-button">
              <FaPlay className="play-icon" />
              Book Your Session Now
            </button>
            <a href="#features" className="scroll-down">
              Explore Our Facilities
              <span className="arrow-down"></span>
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
